module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer002",
      "role": "doc-toc"
    }
  }, [_c('p', {
    staticClass: "TOCtitle"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('a', {
    attrs: {
      "href": "#/The_Texans_Inherited_Family#_idTextAnchor001"
    }
  }, [_vm._v("The Texan’s Inherited Family")]), _vm._v(" by Noelle Marchand")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/A_Home_for_His_Family#_idTextAnchor022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Home for His Family")]), _vm._v(" by Jan Drexler")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_vm._v("Excerpt from "), _c('span', {
    attrs: {
      "href": "#/Excerptone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caring for Her Amish Family")]), _vm._v(" by Carrie Lighte")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d80f62b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table_of_Contents.vue
// module id = 63
// module chunks = 0